import {effect, inject, Injectable, untracked} from '@angular/core'
import {SiteConfigService} from '@/services/site-config.service'
import {BetslipCreateService} from '@/features/betslip/betslip-create/betslip-create.service'
import {withWorkbenchLimits, WorkbenchLimitsState} from './betslip-workbench.store'
import {LiabilityLimitsState, PlayerLiabilityTier} from './liability-limits.state'

/**
 * Dev builds only: the player's betslip runs on the workbench's Betting Limits, for the player the
 * workbench picks — its Auto-accept limit and caps from that player's tier, every other limit once
 * edited. "Not applied" leaves the betslip on the site's own limits. Started by DevToolsComponent,
 * which production builds swap for a no-op.
 */
@Injectable({providedIn: 'root'})
export class PlayerBettingLimitsMock {

	constructor() {
		const state = inject(WorkbenchLimitsState)
		const siteConfig = inject(SiteConfigService)
		const betslip = inject(BetslipCreateService)
		const player = inject(LiabilityLimitsState).playerTier

		// Every edit, and every change of player, calculates the player's betslip again on the new
		// limits — not before the site config has arrived.
		effect(() => {
			const limits = state.limits()
			const tier = player()

			siteConfig.devBettingRules.set(tier === PlayerLiabilityTier.off
				? undefined
				: (rules) => withWorkbenchLimits(rules, limits, tier))

			untracked(() => {
				if (siteConfig.currentConfig) {
					betslip.setStrategy(betslip.getBetslipStrategy())
				}
			})
		})
	}
}
